import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { SlaLevelType } from 'constants/slaGroups';

export const formatSlaGroupLevels = slaGroup => {
  if (!slaGroup?.levels?.length) {
    return [];
  }

  return slaGroup.levels.map(
    ({
      potentialSigners,
      actualSigners,
      eligibleForSignOffDate,
      type,
      slaType,
      ...slaGroupLevel
    }) => {
      const existingPotentialSigners = potentialSigners.filter(({ isDeleted }) => !isDeleted);
      const deletedPotentialSigners = potentialSigners.filter(({ isDeleted }) => isDeleted);
      const existingActualSigners = actualSigners.filter(({ isDeleted }) => !isDeleted);
      const deletedActualSigners = actualSigners.filter(({ isDeleted }) => isDeleted);

      return {
        ...slaGroupLevel,
        type,
        potentialSignersFullNames: existingPotentialSigners
          .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
          .join(', '),
        deletedPotentialSignersFullNames: deletedPotentialSigners
          .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
          .join(', '),
        actualSignersFullNames: existingActualSigners
          .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
          .join(', '),
        deletedActualSignersFullNames: deletedActualSigners
          .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
          .join(', '),
        eligibleForSignOffDate: eligibleForSignOffDate
          ? dayjs(eligibleForSignOffDate).format(COMMON_DATETIME_FORMAT)
          : 'N/A',
        slaType: type === SlaLevelType.USER ? '' : slaType,
        //TODO: sla type condition check as a temporary fix, remove after this logic implemented on BE side
      };
    },
  );
};
